// ?use_ios_ui — twin of iOS 0.7.0 WheelInfoModal: a white card under the
// pill with the brand logo and the model name over a frosted backdrop; a
// tap on the backdrop dismisses. iOS falls back to a bundled logo on a
// failed load; Android has none bundled, so a failed logo is hidden.

import { useState } from 'react'
import { IOS_UI_FONT } from '@/components/ios-ui/ios-ui-palette/ios-ui-palette'

interface WheelInfoModalProps {
  brandLogoURL: string | null
  modelName: string
  onDismiss: () => void
}

export function WheelInfoModal({ brandLogoURL, modelName, onDismiss }: WheelInfoModalProps) {
  const [logoFailed, setLogoFailed] = useState(false)
  return (
    <div style={{ position: 'fixed', inset: 0, fontFamily: IOS_UI_FONT, pointerEvents: 'auto', zIndex: 40 }}>
      <div
        data-testid="ios-modal-backdrop"
        onClick={onDismiss}
        style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.1)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)' }}
      />
      <div
        data-testid="ios-wheel-info-modal"
        style={{
          position: 'absolute',
          top: 'calc(env(safe-area-inset-top, 0px) + 41px)',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 280,
          boxSizing: 'border-box',
          padding: 24,
          borderRadius: 20,
          background: '#FFFFFF',
          boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
        }}
      >
        {brandLogoURL != null && !logoFailed && (
          <img
            data-testid="ios-modal-logo"
            src={brandLogoURL}
            alt=""
            onError={() => setLogoFailed(true)}
            style={{ height: 44, maxWidth: '100%', objectFit: 'contain' }}
          />
        )}
        <div
          data-testid="ios-modal-model"
          style={{ fontSize: 28, fontWeight: 700, color: 'rgb(26,26,26)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}
        >
          {modelName}
        </div>
      </div>
    </div>
  )
}
